import {BaseElement, OSkinableInit} from "/@back@/commons/basis.js";
import {REG} from "/@lib@/commons/registry.js";
import {JSX} from "/@lib@/commons/xml/dom.js";

/**
 * Dialogue "A propos"
 */
export interface AboutDialog extends BaseElement {
	initialize(init?: OAboutDialogInit): this
}

export interface OAboutDialogInit extends OSkinableInit {
	appLogo?: string
	appName?: string
	appVersion?: string
	appBuildId?: string
	appDevelopmentStage?: string
	appReleaseEnvironment?: string

	/** Fragment (x)html ou url de fragement ? */
	appDetails?: string

	/** Coeur SC **/
	scVersion?: string
	scBuildId?: string
}

export class AboutDialog extends BaseElement {

	protected _initialize(init: OAboutDialogInit) {
		const nodeDetails: HTMLElement = <section id="appDetails"/>;
		const scLink: HTMLElement = <a href="https://scenari.software" title="https://scenari.software" target="blank">Scenari</a>;
		if (init.appDetails) nodeDetails.innerHTML = init.appDetails;

		this._attach(this.localName, init, <section id="appHead">
				<img id="appLogo" src={init.appLogo || "/@skin@/core/logoSC.svg"}/>
				<div id="appInfo">
					<div id="appEnvironment" style={init.appReleaseEnvironment ? '' : 'display:none'}>Environnement : <span class="value">{init.appReleaseEnvironment}</span></div>
					<div id="appName">{init.appName}</div>
					<div><span id="appVersion">{init.appVersion}</span> <span id="appDevelopmentStage">{init.appDevelopmentStage}</span> <span id="appBuildId">{init.appBuildId}</span></div>
				</div>
			</section>,
			nodeDetails,
			<section id="scHead">
				<img id="scLogo" src="/@skin@/core/logoSCbuilder.svg"/>
				<div id="scInfo">
					<div id="madeWith">Réalisé avec la solution open-source : {scLink}</div>
					<div id="scCore">Cœur SCENARI <span id="scVersion">{init.scVersion}</span> <span id="scBuildId">{init.scBuildId}</span></div>
				</div>
			</section>
		);
	}
}

REG.reg.registerSkin('c-about', 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		max-width: 50rem;
	}

	a {
		color: var(--color);
	}

	#appHead {
		display: flex;
		min-height: 0;
		min-width: 0;
		margin-bottom: 1em;
		align-items: center;
	}

	#appLogo {
		max-width: 100rem;
		max-height: 5rem;
	}

	#appInfo {
		flex: 1;
		text-align: center;
	}

	#appName {
		font-size: 1.3rem;
	}

	#appVersion, #appDevelopmentStage {
		font-size: 1.3rem;
		color: var(--alt1-color);
	}

	#appEnvironment {
		font-style: italic;
		font-size: 0.7rem;
		text-align: end;
		/*color: var(--alt1-color);*/
	}

	#appBuildId {
		color: var(--alt2-color);
		font-size: .75em;
	}

	#scHead {
		display: flex;
		min-height: 0;
		min-width: 0;
		margin-top: 2em;
		padding-top: 1em;
		border-top: 1px solid var(--border-color);
		align-items: center;
	}

	#scInfo {
		flex: 1;
		margin: 0 .5em;
	}

	#scLogo {
		width: 2rem;
		height: 2rem;
	}

	#madeWith {
	}

	#scCore {
		color: var(--alt1-color);
	}

	#scBuildId {
		color: var(--alt2-color);
		font-size: .75em;
	}

`);

customElements.define('c-about', AboutDialog);
